import checkedIcon from '@icons/checkbox.svg'
import radioSelected from '@icons/radio-selected.svg'
import radioUnselected from '@icons/radio-unselected.svg'
import { uiSize } from '@utils'

const bankyColors = {
  black: 'var(--banky-black)',
  grey: 'var(--banky-grey)',
  radicalRed: 'var(--banky-radical-red)',
  royalBlue: 'var(--banky-royal-blue)',
  royalBlue75: 'var(--legacy-primary-hover-bg)',
  whisper: 'var(--banky-whisper)',
  white: 'var(--banky-white)'
}

const theme = {
  checkedIcon,
  radioSelected,
  radioUnselected,

  fontName: 'Poppins',

  colors: bankyColors,

  toast: {
    error: {
      iconTheme: { primary: 'var(--color-error)', secondary: 'var(--banky-white)' },
      style: {
        color: bankyColors.white,
        fontSize: 'var(--font-size-lg)',
        lineHeight: uiSize(19),
        background: bankyColors.radicalRed,
        borderRadius: uiSize(10)
      }
    },
    success: {
      iconTheme: { primary: 'var(--color-success)', secondary: 'var(--banky-white)' },
      style: {
        color: bankyColors.white,
        fontSize: 'var(--font-size-lg)',
        lineHeight: uiSize(19),
        background: 'var(--toast-success-bg)',
        borderRadius: uiSize(10)
      }
    }
  },

  button: {
    loadingType: 'ThreeDots',
    primary: {
      height: uiSize(44),
      background: bankyColors.royalBlue,
      border: 'none',
      borderRadius: uiSize(10),
      boxShadow: '0 0 10px 0 var(--banky-pale-cornflower-blue)',
      color: bankyColors.white,
      fontSize: 'var(--font-size-lg)',
      fontWeight: '500',
      iconColor: bankyColors.white,
      iconSpacing: uiSize(14),
      padding: `0 ${uiSize(10)}`,

      hoverBackground: bankyColors.royalBlue75,
      hoverBorder: 'none',
      hoverBoxShadow: 'none',
      hoverColor: bankyColors.white,

      disabledColor: bankyColors.white,
      disabledBackground: 'var(--banky-royal-blue--30)', //bankyColors.royalBlue30
      disabledBorder: 'none',
      disabledBoxShadow: 'none'
    },
    secondary: {
      height: uiSize(44),
      background: bankyColors.white,
      border: 'none',
      borderRadius: uiSize(10),
      boxShadow: 'none',
      color: 'var(--banky-nepal)',
      fontSize: 'var(--font-size-lg)',
      fontWeight: '500',
      iconColor: bankyColors.royalBlue75,
      iconSpacing: uiSize(14),
      padding: `0 ${uiSize(10)}`,

      hoverBackground: bankyColors.white,
      hoverBorder: 'none',
      hoverBoxShadow: 'none',
      hoverColor: bankyColors.royalBlue,

      disabledColor: bankyColors.white,
      disabledBackground: 'var(--banky-hawkes-blue)',
      disabledBorder: '1px solid var(--banky-hawkes-blue)',
      disabledBoxShadow: 'var(--shadow-soft)'
    },
    alternative: {
      height: uiSize(44),
      background: 'var(--banky-yellow)',
      border: 'none',
      borderRadius: uiSize(10),
      boxShadow: 'none',
      color: bankyColors.white,
      fontSize: 'var(--font-size-lg)',
      fontWeight: '500',
      iconColor: bankyColors.white,
      iconSpacing: uiSize(10),
      padding: `0 ${uiSize(10)}`,

      hoverBackground: 'var(--banky-kournikova)',
      hoverBorder: 'none',
      hoverBoxShadow: 'none',
      hoverColor: bankyColors.white,

      disabledColor: bankyColors.white,
      disabledBackground: 'var(--banky-hawkes-blue)',
      disabledBorder: 'none',
      disabledBoxShadow: 'var(--shadow-soft)'
    },
    'round-primary': {
      height: uiSize(40),
      background: bankyColors.white,
      border: 'none',
      borderRadius: uiSize(20),
      boxShadow: 'var(--shadow-control)',
      color: bankyColors.black,
      fontSize: 'var(--font-size-base)',
      fontWeight: '600',
      iconColor: 'var(--button-round-icon)',
      iconHeight: uiSize(14),
      iconSpacing: '6px',
      padding: `0 ${uiSize(25)}`,

      hoverBackground: 'var(--banky-ghost-white)',
      hoverBorder: 'none',
      hoverBoxShadow: '0 2px 15px var(--banky-black--15)',
      hoverColor: bankyColors.grey,

      disabledColor: bankyColors.grey,
      disabledBackground: bankyColors.whisper,
      disabledBorder: 'none',
      disabledBoxShadow: 'none'
    },
    'round-secondary': {
      height: uiSize(40),
      background: bankyColors.white,
      border: 'none',
      borderRadius: uiSize(20),
      boxShadow: 'var(--shadow-control)',
      color: bankyColors.black,
      fontSize: 'var(--font-size-base)',
      fontWeight: '600',
      iconColor: 'var(--button-round-icon)',
      iconHeight: uiSize(14),
      iconSpacing: '6px',
      padding: `0 ${uiSize(25)}`,

      hoverBackground: 'var(--button-round-secondary-hover-bg)',
      hoverBorder: 'none',
      hoverBoxShadow: '0 2px 15px var(--banky-black--15)',
      hoverColor: bankyColors.white,

      disabledColor: bankyColors.grey,
      disabledBackground: bankyColors.whisper,
      disabledBorder: 'none',
      disabledBoxShadow: 'none'
    },
    delete: {
      height: uiSize(40),
      background: bankyColors.white,
      border: 'none',
      borderRadius: uiSize(20),
      boxShadow: 'var(--shadow-control)',
      color: 'var(--text-link)',
      fontSize: 'var(--font-size-base)',
      fontWeight: '600',
      iconColor: 'var(--button-round-icon)',
      iconHeight: uiSize(14),
      iconSpacing: '6px',
      padding: `0 ${uiSize(25)}`,

      hoverBackground: bankyColors.white,
      hoverBorder: 'none',
      hoverBoxShadow: '0 2px 15px var(--banky-black--15)',
      hoverColor: 'var(--text-link)',

      disabledColor: bankyColors.grey,
      disabledBackground: bankyColors.whisper,
      disabledBorder: 'none',
      disabledBoxShadow: 'none'
    }
  },

  checkbox: {
    checkedIconBackgroundColor: bankyColors.royalBlue,
    checkedIconBorderColor: bankyColors.white,
    iconBackground: bankyColors.white,
    iconBorder: '1px solid var(--banky-gainsboro)',
    iconBorderRadius: '5px',
    iconSize: '22px',
    fontSize: 'var(--font-size-base)',
    fontStyle: 'normal',
    fontWeight: 'normal',
    textColor: 'var(--text-primary)'
  },

  dataTable: {
    body: {
      backgroundColor: bankyColors.white,
      border: 'none',
      borderColor: bankyColors.whisper,
      textColor: bankyColors.black,
      fontSize: 'var(--font-size-lg)',
      fontWeight: '500',
      dropShadow: 'var(--shadow-control)',
      infoLineColor: 'var(--text-secondary)'
    },
    head: {
      background: 'var(--data-table-header-bg)',
      // border: '2px solid ' + bankyColors.whisper,
      textColor: 'var(--banky-black)',
      fontSize: 'var(--font-size-lg)',
      fontWeight: '500'
    },
    hover: {
      backgroundColor: 'var(--banky-alice-blue)',
      border: `1px solid ${bankyColors.whisper}`,
      textColor: bankyColors.black
    }
  },

  dropTarget: {
    background: 'var(--drop-target-bg)',
    border: 'none',
    borderRadius: uiSize(20),
    textColor: bankyColors.black,
    fontSize: 'var(--font-size-lg)',
    fontWeight: 'normal'
  },

  gridTable: {
    border: `1px solid ${bankyColors.whisper}`,
    fontSize: 'var(--font-size-base)',
    fontSize2: 'var(--font-size-lg)',
    fontWeight: '500',
    lineHeight: uiSize(17),
    lineHeight2: uiSize(20),
    labelColor: 'var(--grid-table-label)',
    valueColor: bankyColors.black,
    negativeColor: 'var(--grid-table-negative)',
    positiveColor: 'var(--grid-table-positive)',
    rowPadding: `${uiSize(10)} 0`,
    totalFontSize: uiSize(20),
    totalFontSize2: uiSize(24),
    totalFontWeight: 'bold',
    totalLineHeight: uiSize(24),
    totalLineHeight2: uiSize(30)
  },

  input: {
    label: {
      textColor: 'var(--text-primary)',
      fontSize: 'var(--font-size-sm)',
      fontWeight: '500',
      lineHeight: uiSize(14),
      textTransform: 'none',
      marginBottom: '5px',
      marginLeft: '0',
      asteriskColor: bankyColors.radicalRed,
      asteriskMargin: '0',
      asteriskPosition: 'right',
      paddingWithIcon: uiSize(24),
      paddingRequired: uiSize(17)
    },
    error: {
      textColor: bankyColors.radicalRed,
      padding: '0',
      marginTop: uiSize(8)
    },
    wrapper: {
      marginBottom: uiSize(20)
    },
    container: {
      textColor: 'var(--text-primary)',
      fontSize: 'var(--font-size-base)',
      fontWeight: 'normal',
      lineHeight: uiSize(17),
      background: bankyColors.white,
      border: '1px solid var(--input-border)',
      borderWidth: '1px',
      borderRadius: uiSize(10),
      padding: `0 ${uiSize(16)}`,
      iconColor: 'var(--banky-nepal)',
      errorBorderColor: bankyColors.radicalRed,
      errorBorderWidth: '1px',
      focusedBorderColor: 'var(--input-focused-border)',
      focusedBorderWidth: '2px'
    },
    placeholder: {
      textColor: 'var(--banky-nepal)',
      fontSize: 'var(--font-size-base)',
      fontWeight: 'normal',
      lineHeight: uiSize(17)
    },
    dropDown: {
      controlBorder: 'none',
      controlBorderRadius: '0',
      controlPadding: '0',
      indicatorColor: 'var(--banky-nepal)',
      menuBackground: bankyColors.white,
      menuBorder: 'none',
      menuBorderRadius: `0 0 ${uiSize(10)} ${uiSize(10)}`,
      menuMargin: '0',
      menuPadding: '0 0 8px',
      openedBackground: 'transparent',
      openedBorder: 'none',
      openedBorderRadius: '0',
      openedColor: 'var(--text-primary)',
      optionBorderRadius: '0',
      optionColor: 'var(--text-primary)',
      optionFontSize: uiSize(14),
      optionFontWeight: 'normal',
      optionLineHeight: uiSize(17),
      optionMargin: '0',
      optionPadding: `${uiSize(10)} ${uiSize(20)}`,
      optionBackground: bankyColors.white,
      focusedOptionColor: bankyColors.black,
      focusedOptionBackground: 'var(--select-option-highlight-bg)', // rgba(163, 177, 191, .1)
      buttonColor: 'var(--select-option-highlight-bg)',
      buttonTextAlign: 'center',
      buttonBorderRadius: '3px',
      buttonBackground: 'var(--select-button-bg)'
    },
    settings: {
      height: uiSize(44),
      singleSelect: false,
      autofillBackground: bankyColors.white,
      dropDownArrowColor: bankyColors.black,
      textareaMargin: '0',
      textareaPadding: `${uiSize(16)} 0`,
      hideLabelWhenEmpty: false,
      showPasswordWithText: false
    }
  },

  radioButton: {
    iconSize: uiSize(24),
    iconSpacing: uiSize(16),
    fontSize: 'var(--font-size-lg)',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: uiSize(20),
    textColor: bankyColors.grey,
    loadingColor: bankyColors.grey,
    loadingSize: '30'
  }
}

export default theme
